<style scoped>
._v_mask {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1500;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}
._v_mask > #imgshow {
  /* max-width: 85%; */
  width: 85%;
  /* height: auto;
  max-height: 90%; */
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
  -ms-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transition: transform 0.2s ease;
}
._v_mask > .prev {
  position: absolute;
  top: 50%;
  left: 36px;
  width: 40px;
  height: 40px;
  background-image: url("../../assets/images/上一张.png");
  background-size: 100%;
  background-repeat: no-repeat;
  transform: translateY(-50%);
}
._v_mask > .next {
  position: absolute;
  top: 50%;
  right: 36px;
  width: 40px;
  height: 40px;
  background-image: url("../../assets/images/下一张.png");
  background-size: 100%;
  background-repeat: no-repeat;
  transform: translateY(-50%);
}
</style>

<template>
  <div>
    <div class="_v_mask" @click="clickMask" @touchmove.prevent>
      <img id="imgshow" ref="_v_img_show" :src="imgList[activeIndex]">
      <div v-if="(imgList.length>1)&&(activeIndex!==0)" class="prev" @click.stop="prevPicture" />
      <div v-if="(imgList.length>1)&&(activeIndex!==imgList.length-1)" class="next" @click.stop="nextPicture" />
    </div>
  </div>
</template>
<script type="text/babel">
import AlloyFinger from 'alloyfinger'
export default {

  components: {},
  props: {
    // imgUrl: String
  },

  data() {
    return {
      af: null,
      mox: null,
      moy: null,
      imgUrl: this.$store.state.imgUrl || '',
      imgList: this.$store.state.imgList || [],
      activeIndex: this.$store.state.activeIndex || 0
    }
  },

  mounted() {
    this.init()
  },

  methods: {
    init() {
      var el = this.$refs['_v_img_show']
      var initScale = 1
      var sc = 1
      var mox, moy
      this.af = new AlloyFinger(el, {
        touchStart: function() {
          mox = parseFloat(
            document.defaultView
              .getComputedStyle(el, null)
              .transform.substring(7)
              .split(',')[4]
          )
          moy = parseFloat(
            document.defaultView
              .getComputedStyle(el, null)
              .transform.substring(7)
              .split(',')[5]
          )
        },
        doubleTap: function(evt) {
          if (sc > 1.5) {
            sc = 1
          } else {
            sc = 2
          }
          el.style.webkitTransform =
              'translateX(' +
              mox +
              'px) translateY(' +
              moy +
              'px) scale(' +
              sc +
              ')'
          // console.log("doubleTap");
        },
        pressMove: function(evt) {
          mox += evt.deltaX
          moy += evt.deltaY
          el.style.webkitTransform =
            'translateX(' +
            mox +
            'px) translateY(' +
            moy +
            'px) scale(' +
            sc +
            ')'
          evt.preventDefault()
        },

        pinch: function(evt) {
          console.log(evt)
          sc = initScale * evt.zoom
          el.style.webkitTransform = 'scale(' + sc + ')'
          if (sc < 0.3) {
            el.style.webkitTransform = 'scale(0.3)'
          } else {
            el.style.webkitTransform = 'scale(' + sc + ')'
          }
        },
        multipointStart: function() {
          initScale = parseFloat(
            document.defaultView
              .getComputedStyle(el, null)
              .transform.substring(7)
              .split(',')[0]
          )
        }
        // swipe: function (evt) {
        //     console.log(evt);
        //     console.log("swipe" + evt.direction);
        // }
      })
    },
    clickMask(e) {
      if (e.target == this.$refs['_v_img_show']) return
      this.$store.commit('closeImgView')
    },
    prevPicture() {
      // let index = this.imgList.findIndex(v=>v===this.imgUrl);
      // this.imgUrl = this.imgList[this.activeIndex--];
      this.activeIndex--
      this.renewLocation()
    },
    nextPicture() {
      // let index = this.imgList.findIndex(v=>v===this.imgUrl);
      // this.imgUrl = this.imgList[this.activeIndex++];
      this.activeIndex++
      this.renewLocation()
    },
    renewLocation() {
      this.$refs['_v_img_show'].style.webkitTransform =
        'translateX(' + 0 + 'px) translateY(' + 0 + 'px) scale(' + 1 + ')'
    }
  }
}
</script>
